<template>
  <div class="">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <!-- <DeleteAlarm
      v-if="removeGroupDeviceModal"
      :show="removeGroupDeviceModal"
      :removedId="removedId"
      v-on:closeRemoveGroupDevice="removeGroupDeviceModal = false"
    /> -->
    <!-- <div class="d-flex">
      <label
        for="snooze"
        class="d-flex align-items-center gray4 ml-auto cursor-pointer"
        style="column-gap:5px"
      >
        <input
          type="checkbox"
          id="snooze"
          @change="handleSnooze"
          :checked="isSnoozed"
        />
        {{ $t('snooze_alarm') }}
      </label>
    </div> -->
    <DeleteModal
      :show="openDelete"
      @close="
        openDelete = false;
        alarmId = '';
      "
      name="Alarm"
      @submit="doDeleteAlarm"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="$t('success_msg_alarm_delete')"
      :heading="$t('success_heading_alarm_delete')"
    />

    <div class="card" style="max-height: 40rem; overflow-y: auto">
      <div class="card-body">
        <div class="col-sm-12 col-md-12 mb-3">
          <div class="d-flex align-items-center justify-content-between">
            <p class="mb-0 font-14 font-weight-bold" style="text-transform: capitalize;">
              {{ $t('alarms') }}
            </p>
            <TableSearch @handleSearch="handleSearch" />
          </div>
        </div>
        <!-- <div
          class="delete-all d-flex align-items-center justify-content-between p-2"
          :class="isAllSelected ? 'show-delete-all mb-2' : 'mb-0'"
          style="border-radius: 8px;"
        >
          <p class="mb-0">{{ $t("delete_all_alarms") }}</p>
          <span @click="doOpenDelete(alarm.id)" class="cursor-pointer">
            <IconDelete />
          </span>
        </div> -->
        <div class="row">
          <div class="col-md-12">
            <div ref="content" class="table-responsive">
              <table id="order-listing" class="table table-hover display">
                <thead class="data-table-bg">
                  <tr>
                    <!-- <th style="width: 20px;">
                      <input
                        type="checkbox"
                        @change="$emit('select_all')"
                        :checked="isAllSelected"
                      />
                    </th> -->
                    <template v-for="(column, index) in tableColumns">
                      <th
                        v-if="shouldDisplayAction(index)"
                        :key="index"
                        @click="sortBy(column[1])"
                        style="cursor: pointer; text-align: left"
                      >
                        {{ column[0] }}
                        <span
                          class="arrow"
                          :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                        ></span>
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="cursor: pointer"
                    :key="index"
                    v-for="(alarm, index) in paginatedData"
                    class="position-relative"
                    :class="{
                      'data-table-bg': index % 2 !== 0,
                    }"
                    @click="viewAlarm(alarm.id)"
                  >
                    <!-- <td
                      style="min-width:unset"
                      @click.stop="$emit('alarm_clicked', alarm.id)"
                    >
                      <input
                        type="checkbox"
                        :checked="alarmsIdsArray.includes(alarm.id)"
                      />
                    </td> -->
                    <td>
                      <!-- <span class="snooze-container"
                        ><img
                          src="../../assets/images/fluent_alert-snooze-20-regular.png"
                          alt=""
                          v-if="alarm.snooze"
                      /></span> -->
                      {{ alarm.title }}
                    </td>
                    <td>{{ alarm.devices.length }}</td>
                    <td>
                      {{ alarm.notify.emails.length }}
                    </td>
                    <td>
                      {{ alarm.notify.phones.length }}
                    </td>
                    <td>
                      <div
                        v-if="alarm.settings.snooze"
                        class="d-flex align-items-center col-gap-1"
                      >
                        <div
                          style="
                            height: 0.8rem;
                            width: 0.8rem;
                            border-radius: 0.4rem;
                          "
                          class="bg-danger"
                        ></div>
                        {{ $t("snoozed") }}
                      </div>
                      <div v-else class="d-flex align-items-center col-gap-1">
                        <div
                          style="
                            height: 0.8rem;
                            width: 0.8rem;
                            border-radius: 0.4rem;
                          "
                          class="bg-success"
                        ></div>
                        {{ $t("active") }}
                      </div>
                    </td>
                    <td
                      style="
                        font-weight: bolder;
                        padding-left: 2rem;
                        position: relative;
                      "
                      v-if="canPerformAction('alarms', 'edit')"
                    >
                      <div class="d-flex align-items-center col-gap-1">
                        <span
                          @click.stop="openEdit(alarm)"
                          class="cursor-pointer"
                        >
                          <IconEdit />
                        </span>

                        <span
                          @click.stop="doOpenDelete(alarm.id)"
                          class="cursor-pointer"
                        >
                          <IconDelete />
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Pagination
          :pageCount="pageCount"
          :data="paginatedData"
          :sizeperpage="sizeperpage"
          :pageNumber="pageNumber"
          :pages="pages"
          @goToLastPage="goToLastPage"
          @nextPage="nextPage"
          @handlePageChange="handlePageChange"
          @goToFirstPage="goToFirstPage"
          @prevPage="prevPage"
          @onchange="onchange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import store from "../../store/index";
import introJs from "intro.js";
import "intro.js/introjs.css";
import { bus } from "../../main";
import tableMixin from "../../mixins/tableMixinWithBackend";
import Pagination from "../../components/PaginationNew.vue";
import TableSearch from "../../components/TableSearch.vue";
import DeleteModal from "../Modals/DeleteModal.vue";
import SuccessModal from "../Modals/SuccessModal.vue";
import IconEdit from "../../components/Iconsvg/IconEditUser.vue";
import IconDelete from "../../components/Iconsvg/IconDeleteUser.vue";

export default {
  name: "AlarmsCreated",
  components: {
    Loading,
    Pagination,
    TableSearch,
    DeleteModal,
    IconEdit,
    IconDelete,
    SuccessModal,
  },
  mixins: [tableMixin],
  props: {
    alarmsIdsArray: Array,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      showDropdown: null,
      openDelete: false,
      alarmId: "",
      showSuccessPopup: false,
      dataTable: [],
    };
  },
  mounted() {
    this.handleAlarmChange(this.params);
  },
  beforeRouteEnter(to, from, next) {
    // Checks if the user is a staff
    if (store.getters.profile.role === "staff") {
      next(from);
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    introJs().exit();
    next();
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  methods: {
    ...mapActions(["getalarms", "deleteAlarm", "snoozeAlarms"]),
    shouldDisplayAction(index) {
      console.log("action gotten", this.tableColumns.length, index);
      if (index !== this.tableColumns.length - 1) return true;
      if (this.canPerformAction("alarms", "edit")) return true;
      else return false;
    },
    openEdit(e) {
      this.$router.push(`/alarms/${e.id}/settings`);
    },
    closeEdit() {
      if (this.showDropdown !== null && this.delEditOptions)
        this.showDropdown = null;
    },
    openOptions(e) {
      if (!this.delEditOptions) {
        this.showDropdown = e;
        this.delEditOptions = true;
      } else {
        this.showDropdown = null;
        this.delEditOptions = false;
      }
    },
    doDeleteAlarm(e = this.alarmId) {
      this.isLoading = true;
      this.deleteAlarm(e)
        .then((res) => {
          // this.mssg =
          //   res.data.message[0].toUpperCase() + res.data.message.slice(1);
          bus.$emit("deleted", this.mssg);
          this.openDelete = false;
          this.getalarms().then(() => {
            this.isLoading = false;
          });

          // if (res.data.status === 'success') {
          //   setTimeout(() => {
          //     this.isLoading = true;
          //   }, 1000);
          // }
          // setTimeout(() => {
          //   this.mssg = "";
          // }, 4000);
          this.showSuccessPopup = true;
          this.openDelete = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          bus.$emit("deleted", this.Errormssg);
          if (error.response) {
            //console.log(error.response.data.message);
          }
        });
    },
    doOpenDelete(id) {
      this.alarmId = id;
      this.openDelete = true;
    },
    viewAlarm(id) {
      // Use absolute path to work under tabbed parent route
      this.$router.push(`/alarms/${id}/details`);
    },
    doSearch() {
      let params = {
        ...this.params,
        keyword: this.searchQuery,
      };
      this.handleAlarmChange(params);
    },
    handleAlarmChange(params) {
      this.isLoading = true;
      this.getalarms(params)
        .then(() => {
          this.isLoading = false;
          this.dataTable = this.alarms;
        })
        .catch((error) => {
          this.isLoading = false;
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },

  computed: {
    ...mapGetters(["alarms", "alarmsMeta", "canPerformAction"]),
    isSnoozed() {
      return this.alarms.every((alarm) => alarm.snooze);
    },
    snoozeText() {
      return this.isSnoozed ? "Unsnooze" : "Snooze";
    },
    isAllSelected() {
      return this.alarmsIdsArray.length === this.alarms.length;
    },
    paginationMeta() {
      return this.alarmsMeta;
    },
    tableColumns() {
      return [
        [this.$t("alm_title"), "title"],
        [this.$t("no-of-devices"), "devices"],
        [this.$t("no-of-emails"), "emails"],
        [this.$t("no-of-phones"), "phones"],
        [this.$t("status"), "snooze"],
        [this.$t("action"), ""],
      ];
    },
  },
  watch: {
    params() {
      this.handleAlarmChange(this.params);
    },
  },
};
</script>
<style src="../../assets/css/style.css"></style>
<style scoped>
td {
  /* border-bottom: 1px rgba(0, 0, 0, 0.1) solid; */
}
th,
td {
  min-width: 150px;
  text-align: start;
}
th.active {
  color: #fff;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.flex {
  display: flex;
}
.edit-drop {
  position: absolute;
  display: flex;
  flex-flow: column;
  right: 4rem;
  top: 2.5rem;
  background: #ffffff;
  /* border: 0.3px solid rgba(183, 195, 205, 0.4); */
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
  border-radius: 1px;
  z-index: 2;
}
.edit-drop span {
  padding: 0.5rem 2rem;
  border: 0.3px solid rgba(183, 195, 205, 0.4);
  cursor: pointer;
}
.edit-drop span:hover {
  background-color: rgba(236, 236, 236, 0.33);
}
.snooze-container {
  width: 22px;
  display: inline-block;
}
.title-heading {
  padding-left: 45px;
}
.delete-all {
  background: #ffe4e4;
  color: #dc3030;

  transition: clip-path 0.4s ease;
  clip-path: inset(0 0 100% 0);
}
.show-delete-all {
  clip-path: inset(0 0 0 0);
}
</style>

<i18n>
{
	"en": {
		"action": "Action",
		"alm_title": "Alarm Name",
		"alm_type": "Alarm Type",
		"del": "Delete",
		"edit": "Edit",
		"is": "is",
		"notif_me": "Notify me when",
		"notif_type": "Notification Type",
		"notif_wen": "Notify when device is ",
		"of_geo": "Geofence",
		"test": {
			"save": "Testing how to save"
		},
		"than": "than",
		"within": "within"
	},
	"es": {
		"action": "Acción",
		"alm_title": "Título de la alarma",
		"alm_type": "Tipo de alarma",
		"del": "Borrar",
		"edit": "Editar",
		"is": "ES",
		"notif_me": "Notifícame cuando",
		"notif_type": "tipo de notificación",
		"notif_wen": "Notificar cuando el dispositivo está",
		"of_geo": "de Geofence",
		"test": {
			"save": "Probando cómo ahorrar"
		},
		"than": "Que",
		"within": "Dentro de"
	},
	"fr": {
		"action": "action",
		"alm_title": "Titre de l'alarme",
		"alm_type": "Type d'alarme",
		"del": "Effacer",
		"edit": "modifier",
		"is": "est",
		"notif_me": "Prévenez-moi quand",
		"notif_type": "type de notification",
		"notif_wen": "Avertir lorsque l'appareil est",
		"of_geo": "de Geofence",
		"test": {
			"save": "Tester comment économiser"
		},
		"than": "Que",
		"within": "dans"
	},
	"sw": {
		"action": "Hatua",
		"alm_title": "Kichwa cha Kengele",
		"alm_type": "Aina ya Kengele",
		"del": "Futa",
		"edit": "Hariri",
		"is": "ni",
		"notif_me": "Nijulishe lini",
		"notif_type": "Aina ya Arifa",
		"notif_wen": "Arifu wakati kifaa kipo",
		"of_geo": "Geofence",
		"test": {
			"save": "Kujaribu jinsi ya kuokoa"
		},
		"than": "kuliko",
		"within": "ndani"
	}
}
</i18n>
